import {
    GET_ASSET_ITEM_STATUS_PURCHASE_ORDER,
    SET_ASSET_ITEM_STATUS_PURCHASE_ORDER,
    SET_IS_ASSET_ITEM_STATUS_PURCHASE_ORDER_CALLED
} from "./AssetItemStatusPurchaseOrderType"

const getAssetItemStatusPurchaseOrder = (fleetDetailId: any) => ({
    type: GET_ASSET_ITEM_STATUS_PURCHASE_ORDER,
    fleetDetailId
})

const setAssetItemStatusPurchaseOrder = (assetItemStatusPurchaseOrder: any) => ({
    type: SET_ASSET_ITEM_STATUS_PURCHASE_ORDER,
    assetItemStatusPurchaseOrder: assetItemStatusPurchaseOrder
})

const SetIsAssetItemStatusPurchaseOrderCalled = (fleetDetailId : any , isLoading : any) => {
    return {
      type: SET_IS_ASSET_ITEM_STATUS_PURCHASE_ORDER_CALLED,
      fleetDetailId,
      isLoading: isLoading
    };
}


export {
    getAssetItemStatusPurchaseOrder,
    setAssetItemStatusPurchaseOrder,
    SetIsAssetItemStatusPurchaseOrderCalled
}